import React from 'react';
import BrandedAlertModal from '../../../../../components/Modal/BrandedAlertModal/BrandedAlertModal';

interface TermsModalProps {
  isOpen: boolean;
  onAgree: () => void;
}

// T2-6047: Restyled to use the shared BrandedAlertModal so the DO "agree to
// terms" pop-up matches the brand-design pattern used by the Paid Shift
// Confirmation modal and other branded prompts.
const HeaderIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path
      d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14 3v6h6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const Illustration: React.FC = () => (
  <svg viewBox="0 0 64 64" fill="none" aria-hidden="true" focusable="false">
    <rect x="14" y="8" width="36" height="48" rx="4" stroke="currentColor" strokeWidth="2.5" />
    <path d="M22 22h20M22 30h20M22 38h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="46" cy="46" r="9" fill="#13CA82" />
    <path d="M42 46l3 3 6-6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onAgree }) => {
  const siteUrl = (window as any)?.TempStars?.Config?.web?.siteUrl || 'tempstars.com';

  return (
    <BrandedAlertModal
      isOpen={isOpen}
      headerLabel="Terms of Service Update"
      headerIcon={<HeaderIcon />}
      illustration={<Illustration />}
      illustrationVariant="info"
      title="We've Updated Our Terms"
      ariaLabel="Terms of Service Update"
      actions={[{ label: 'I Agree', variant: 'primary', onClick: onAgree }]}
    >
      We have made important updates to our Terms of Service.{' '}
      <a
        href={`https://${siteUrl}/terms`}
        target="_blank"
        rel="noreferrer"
        style={{ color: 'var(--primary-blue, #0B4598)', fontWeight: 600 }}
      >
        Click here to review our Terms of Service
      </a>
      . Please read carefully and agree below to proceed.
    </BrandedAlertModal>
  );
};

export default TermsModal;
